import type { AuditAction, AuditEntry } from '@/lib/clinic/types'

import { nowIso } from '@/lib/clinic/datetime'

const MAX_HISTORY = 50

export const createAudit = (action: AuditAction, summary: string, at: string = nowIso()): AuditEntry => ({
    at,
    action,
    summary
})

export const appendHistory = (history: AuditEntry[], entries: AuditEntry[]): AuditEntry[] => {
    return [...history, ...entries].slice(-MAX_HISTORY)
}

export const changedLabels = <T extends object>(before: T, after: T, labels: Partial<Record<keyof T, string>>): string[] => {
    return (Object.keys(labels) as Array<keyof T>)
        .filter(key => JSON.stringify(before[key]) !== JSON.stringify(after[key]))
        .map(key => labels[key] as string)
}

export const summarizeChanges = (labels: string[]): string => {
    if (labels.length === 0) return 'Saved without changes'
    if (labels.length === 1) return `Updated ${labels[0]}`

    return `Updated ${labels.slice(0, -1).join(', ')} and ${labels[labels.length - 1]}`
}

export const withReason = (summary: string, reason?: string): string => {
    const trimmed = reason?.trim()

    return trimmed ? `${summary}. Reason: ${trimmed}` : summary
}
